import { render, staticRenderFns } from "./add-btn.vue?vue&type=template&id=4c4512ba&"
import script from "./add-btn.vue?vue&type=script&lang=ts&"
export * from "./add-btn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports